module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"block\">\r\n    <h2 id=\"test\">Details</h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Agent URL</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"connection\" name=\"_url\" tabindex=\"0\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_url'] ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Username</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"text\" name=\"_username\" autocomplete=\"false\" tabindex=\"0\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_username']))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Password</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"password\" name=\"_password\" autocomplete=\"new-password\" tabindex=\"0\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_password']))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Timeout</span>\r\n        </div>\r\n        <div class=\"col-sm-2\">\r\n            <input type=\"text\" name=\"_timeout\" tabindex=\"0\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_timeout'] ))
    ; __append("\"/>\r\n        </div>\r\n        <div class=\"col-sm-7 nopadding\">\r\n            <div class=\"middle-align\">seconds</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Use Proxy (for SSL)</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"checkbox\" name=\"_useProxy\" tabindex=\"0\" ")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_useProxy'] === 'true' ? " checked" : "" ))
    ; __append("/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\"></div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"button\" name=\"checkConnection\" tabindex=\"0\" value=\"Check\" />\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Datasource</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <select name=\"_datasourceName\" tabindex=\"0\">\r\n                ")
    ;  if(currentConnectionDetails.ConnectionXML.Connection["_datasourceName"] !== '' && databaseConnections.length === 0){
    ; __append("\r\n                   <option value=\"")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_datasourceId']))
    ; __append("\" selected=\"selected\">")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_datasourceName']))
    ; __append("</option>\r\n               ")
    ; } else { 
    ; __append("\r\n                    ")
    ; databaseConnections.map(function(conn){
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(conn['_id']))
    ; __append("\">")
    ; __append(escapeFn(conn['_name']))
    ; __append("</option>\r\n                    ")
    ;  }); 
                  } 
    ; __append(" \r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Database</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <select name=\"_databaseName\" tabindex=\"0\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_databaseId'] ))
    ; __append("\">\r\n              ")
    ;  if((currentConnectionDetails.ConnectionXML.Connection["_datasourceId"] !== '' && currentConnectionDetails.ConnectionXML.Connection["_databaseId"] !== '') 
              && (!databaseConnections || databaseConnections.length === 0)){
    ; __append("\r\n                     <option value=\"")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_databaseId']))
    ; __append("\" selected=\"selected\">")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_databaseName']))
    ; __append("</option>\r\n               ")
    ; } else { 
    ; __append("\r\n                    ")
    ; 
                    databaseConnections.map(function(conn){
                        if(!conn.database) {
                            return;
                        }

                        if(conn._id != currentConnectionDetails.ConnectionXML.Connection['_datasourceId']){
                            return;
                        }
                        else {
                            console.log(conn);
                        }
                        
                        if(Object.prototype.toString.call(conn.database) == '[object Object]'){
                            conn.database = [conn.database];
                        }

                        conn.database.map(function(db)
                        {
                            if (db._id === currentConnectionDetails.ConnectionXML.Connection['_databaseId']){
    ; __append("\r\n                                <option value=\"")
    ; __append(escapeFn(db._id))
    ; __append("\" selected=\"selected\">")
    ; __append(escapeFn(db._name))
    ; __append("</option>                        \r\n                            ")
    ; }else{
    ; __append("\r\n                                <option value=\"")
    ; __append(escapeFn(db._id))
    ; __append("\">")
    ; __append(escapeFn(db._name))
    ; __append("</option>\r\n                            ")
    ; }
                        });
                    });
               } 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}